import "../stylesheets/style_front_qa";
require("modules/front/qa/common.js");
require("modules/front/qa/form.js");
require("modules/front/make_city_list");
